// ** React Imports
import { createElement } from "react";

// ** Third Party Components
import styled from "styled-components";

//##################################

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const SeekBarContainer = styled(({ height, ...props }) =>
	createElement("div", props)
)`
	position: relative;
	height: ${({ height }) => height || "5px"};
	width: 100%;
	margin: 0 auto;
	background-color: ${({ theme: { colors } }) => colors.whiteTrueAlways};
	cursor: pointer;
`;

export const SeekBarLoaded = styled.div.attrs((props) => ({
	style: {
		width: props.loaded,
	},
}))`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1;
	height: 100%;
	background-color: #e2e2e2;
`;

export const SeekBarPlayed = styled.div.attrs((props) => ({
	style: {
		width: props.played,
	},
}))`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 2;
	height: 100%;
	background-color: ${({ theme: { colors, isDarkMode } }) =>
		isDarkMode ? colors.primaryLight : colors.primary};
`;

export const SeekBarPlayedInput = styled("input").attrs({
	type: "range",
})`
	position: absolute;
	left: 0;
	z-index: 3;
	height: 100%;
	width: 100%;
	cursor: pointer;

	&::-webkit-slider-thumb {
		cursor: pointer;
		-webkit-appearance: none;
		height: 5px;
		width: 5px;
		background-color: transparent;
	}
	&::-moz-range-thumb {
		opacity: 0;
		height: 5px;
		width: 5px;
	}
`;
